import React, {PropTypes} from 'react';
import Panel from 'shared/Panel.jsx'; 
import CaptainEntryChangeCaptainFormModalContainer from './CaptainEntryChangeCaptainFormModalContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const CaptainEntryOptions = ({  
  hasSelectedVirtualEntries,
  hasSelectedEntries,
  changeMultipleEntriesErrors,
  onChangeEntriesCaptainClick
}) => (
  <div> 
    <Panel className="panel-primary">
      <div className="row vertical-center">
        <div className="col-sm-6 col-xs-12">
          <h3 className="panel-title"
              style={{display: 'inline-block', marginBottom: 10, marginTop: 6}}>
            {`Change entries`}
          </h3> 
        </div>
        <div className="col-sm-6 col-xs-12 flex vertical-center right">
          <button
            style={{minWidth: 150, marginLeft: 10}}
            type="button"
            className="btn btn-default btn-lg"
            disabled={!hasSelectedEntries && !hasSelectedVirtualEntries}
            onClick={onChangeEntriesCaptainClick}>
            {'Change Captain'}
          </button>
        </div>
        
        <DisplayIf condition={changeMultipleEntriesErrors != undefined && changeMultipleEntriesErrors != ''}> 
          <div className="col-xs-12">
            <br/>
            <div id="sharedErrorList"  
              className="alert alert-danger col-xs-12">
              <ul>
                {changeMultipleEntriesErrors}
              </ul>
            </div>
          </div>
        </DisplayIf>
      </div>
    </Panel>
    <CaptainEntryChangeCaptainFormModalContainer/>
  </div>
);

CaptainEntryOptions.propTypes = {  
  hasSelectedEntries: PropTypes.bool,
  hasSelectedVirtualEntries: PropTypes.bool,
  changeMultipleEntriesErrors: PropTypes.string,
  onChangeEntriesCaptainClick: PropTypes.func
};

export default CaptainEntryOptions;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/CaptainEntryOptions.jsx